export const ReiTypeRisk = 'risk';
export const ReiTypeEtiology = 'etiology';
export const ReiTypeImpairment = 'impairment';
export const ReiTypeInjury = 'injury';
